import { HomePage } from 'features/home/components/HomePage';
import { Navigate, Route, Routes } from 'react-router-dom';

export function HomePageRoutes() {
    return (
        <Routes>
            <Route path='/*' element={<Navigate to='.' />} />
            <Route path='/' element={<HomePage />} />
        </Routes>
    );
}
